import { Boxes, LogOut, User } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const GloGridMark = ({ className = "h-9 w-9" }) => (
  <div
    className={`${className} grid place-items-center rounded-sm bg-slate-900 text-white`}
    aria-hidden="true"
  >
    <Boxes className="h-5 w-5" strokeWidth={2.2} />
  </div>
);

export default function Header() {
  const { user, isAuthed, openLogin, logout } = useAuth();
  return (
    <header
      className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-xl"
      data-testid="app-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3.5 md:px-12">
        <a
          href="https://www.glogrid.com"
          className="flex items-center gap-3 group"
          data-testid="brand-link"
        >
          <GloGridMark />
          <div className="leading-none">
            <div className="font-heading text-lg font-extrabold tracking-tight text-slate-900">
              GloGrid
            </div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400">
              VMI Quoter
            </div>
          </div>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <Link
            to="/lookup"
            className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-slate-900"
            data-testid="nav-lookup"
          >
            Look up quote
          </Link>
          <Link
            to="/compare"
            className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-slate-900"
            data-testid="nav-compare"
          >
            Compare
          </Link>
          <a
            href="https://www.glogrid.com"
            className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-slate-900"
            data-testid="nav-about"
          >
            About GloGrid
          </a>
          {isAuthed ? (
            <div className="flex items-center gap-3" data-testid="auth-user">
              <span className="hidden items-center gap-1.5 text-sm font-medium text-slate-600 lg:flex">
                <User className="h-4 w-4 text-slate-400" />
                {user.email}
                {user.unlimited && (
                  <span className="rounded-sm bg-blue-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-blue-700">Owner</span>
                )}
              </span>
              <button
                onClick={logout}
                className="inline-flex items-center gap-1.5 rounded-sm border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-100"
                data-testid="logout-btn"
              >
                <LogOut className="h-4 w-4" /> Log out
              </button>
            </div>
          ) : (
            <button
              onClick={openLogin}
              className="rounded-sm bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-blue-600"
              data-testid="login-btn"
            >
              Sign in
            </button>
          )}
          <a
            href="mailto:connect@glogrid.com?subject=VMI%20Quote%20Consultation"
            className="hidden rounded-sm border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors duration-200 hover:bg-slate-100 md:inline-block"
            data-testid="header-cta"
          >
            Talk to Sales
          </a>
        </nav>
      </div>
    </header>
  );
}
